import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5a637598&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./electron-scss/index.scss?vue&type=style&index=0&id=5a637598&prod&lang=scss&scoped=true&external"
import style1 from "./Index.vue?vue&type=style&index=1&id=5a637598&prod&lang=scss&scoped=true"
import style2 from "./Index.vue?vue&type=style&index=2&id=5a637598&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_underscore@1.13.8_vue-t_oz4jpprlle4dra2pgsz5us5kba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a637598",
  null
  
)

export default component.exports